import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// utils
import localStorageAvailable from '../utils/localStorageAvailable';
//
import { defaultLang } from './config-lang';
//
import afZALocales from './langs/af-ZA';
import arILLocales from './langs/ar-IL';
import bgBGLocales from './langs/bg-BG';
import bnINLocales from './langs/bn-IN';
import csCZLocales from './langs/cs-CZ';
import daDKLocales from './langs/da-DK';
import deATLocales from './langs/de-AT';
import deBELocales from './langs/de-BE';
import deCHLocales from './langs/de-CH';
import deDELocales from './langs/de-DE';
import elGRLocales from './langs/el-GR';
import enAULocales from './langs/en-AU';
import enCALocales from './langs/en-CA';
import enGBLocales from './langs/en-GB';
import enIELocales from './langs/en-IE';
import enNZLocales from './langs/en-NZ';
import enPHLocales from './langs/en-PH';
import enSGLocales from './langs/en-SG';
import enUSLocales from './langs/en-US';
import enZALocales from './langs/en-ZA';
import esARLocales from './langs/es-AR';
import esCLLocales from './langs/es-CL';
import esCOLocales from './langs/es-CO';
import esESLocales from './langs/es-ES';
import esMXLocales from './langs/es-MX';
import esPRLocales from './langs/es-PR';
import esUSLocales from './langs/es-US';
import etEELocales from './langs/et-EE';
import fiFILocales from './langs/fi-FI';
import frBELocales from './langs/fr-BE';
import frCALocales from './langs/fr-CA';
import frCHLocales from './langs/fr-CH';
import frFRLocales from './langs/fr-FR';
import guINLocales from './langs/gu-IN';
import heILLocales from './langs/he-IL';
import hiINLocales from './langs/hi-IN';
import hrHRLocales from './langs/hr-HR';
import huHULocales from './langs/hu-HU';
import itCHLocales from './langs/it-CH';
import itITLocales from './langs/it-IT';
import jaJPLocales from './langs/ja-JP';
import kaGELocales from './langs/ka-GE';
import knINLocales from './langs/kn-IN';
import koKRLocales from './langs/ko-KR';
import mlINLocales from './langs/ml-IN';
import mrINLocales from './langs/mr-IN';
import nbNOLocales from './langs/nb-NO';
import nsoZALocales from './langs/nso-ZA';
import orINLocales from './langs/or-IN';
import paINLocales from './langs/pa-IN';
import nlBELocales from './langs/nl-BE';
import nlNLLocales from './langs/nl-NL';
import plPLLocales from './langs/pl-PL';
import ptBRLocales from './langs/pt-BR';
import ptPTLocales from './langs/pt-PT';
import roROLocales from './langs/ro-RO';
import ruRULocales from './langs/ru-RU';
import skSKLocales from './langs/sk-SK';
import srRSLocales from './langs/sr-RS';
import stZALocales from './langs/st-ZA';
import svFILocales from './langs/sv-FI';
import svSELocales from './langs/sv-SE';
import taINLocales from './langs/ta-IN';
import teINLocales from './langs/te-IN';
import thTHLocales from './langs/th-TH';
import tnZALocales from './langs/tn-ZA';
import trTRLocales from './langs/tr-TR';
import urINLocales from './langs/ur-IN';
import xhZALocales from './langs/xh-ZA';
import zhCNLocales from './langs/zh-CN';
import zhSGLocales from './langs/zh-SG';
import zhTWLocales from './langs/zh-TW';
import zuZALocales from './langs/zu-ZA';

// ----------------------------------------------------------------------

let lng = defaultLang.value;
let resources = {
  'af-ZA': { translations: afZALocales },
  'ar-IL': { translations: arILLocales },
  'bg-BG': { translations: bgBGLocales },
  'bn-IN': { translations: bnINLocales },
  'cs-CZ': { translations: csCZLocales },
  'da-DK': { translations: daDKLocales },
  'de-AT': { translations: deATLocales },
  'de-BE': { translations: deBELocales },
  'de-CH': { translations: deCHLocales },
  'de-DE': { translations: deDELocales },
  'el-GR': { translations: elGRLocales },
  'en-AU': { translations: enAULocales },
  'en-CA': { translations: enCALocales },
  'en-GB': { translations: enGBLocales },
  'en-IE': { translations: enIELocales },
  'en-NZ': { translations: enNZLocales },
  'en-PH': { translations: enPHLocales },
  'en-SG': { translations: enSGLocales },
  'en-US': { translations: enUSLocales },
  'en-ZA': { translations: enZALocales },
  'es-AR': { translations: esARLocales },
  'es-CL': { translations: esCLLocales },
  'es-CO': { translations: esCOLocales },
  'es-ES': { translations: esESLocales },
  'es-MX': { translations: esMXLocales },
  'es-PR': { translations: esPRLocales },
  'es-US': { translations: esUSLocales },
  'et-EE': { translations: etEELocales },
  'fi-FI': { translations: fiFILocales },
  'fr-BE': { translations: frBELocales },
  'fr-CA': { translations: frCALocales },
  'fr-CH': { translations: frCHLocales },
  'fr-FR': { translations: frFRLocales },
  'gu-IN': { translations: guINLocales },
  'he-IL': { translations: heILLocales },
  'hi-IN': { translations: hiINLocales },
  'hr-HR': { translations: hrHRLocales },
  'hu-HU': { translations: huHULocales },
  'it-CH': { translations: itCHLocales },
  'it-IT': { translations: itITLocales },
  'ja-JP': { translations: jaJPLocales },
  'ka-GE': { translations: kaGELocales },
  'kn-IN': { translations: knINLocales },
  'ko-KR': { translations: koKRLocales },
  'ml-IN': { translations: mlINLocales },
  'mr-IN': { translations: mrINLocales },
  'nb-NO': { translations: nbNOLocales },
  'nso-ZA': { translations: nsoZALocales },
  'or-IN': { translations: orINLocales },
  'pa-IN': { translations: paINLocales },
  'nl-BE': { translations: nlBELocales },
  'nl-NL': { translations: nlNLLocales },
  'pl-PL': { translations: plPLLocales },
  'pt-BR': { translations: ptBRLocales },
  'pt-PT': { translations: ptPTLocales },
  'ro-RO': { translations: roROLocales },
  'ru-RU': { translations: ruRULocales },
  'sk-SK': { translations: skSKLocales },
  'sr-RS': { translations: srRSLocales },
  'st-ZA': { translations: stZALocales },
  'sv-FI': { translations: svFILocales },
  'sv-SE': { translations: svSELocales },
  'ta-IN': { translations: taINLocales },
  'te-IN': { translations: teINLocales },
  'th-TH': { translations: thTHLocales },
  'tn-ZA': { translations: tnZALocales },
  'tr-TR': { translations: trTRLocales },
  'ur-IN': { translations: urINLocales },
  'xh-ZA': { translations: xhZALocales },
  'zh-CN': { translations: zhCNLocales },
  'zh-SG': { translations: zhSGLocales },
  'zh-TW': { translations: zhTWLocales },
  'af': { translations: afZALocales },
  'ar': { translations: arILLocales },
  'bg': { translations: bgBGLocales },
  'cs': { translations: csCZLocales },
  'da': { translations: daDKLocales },
  'de': { translations: deBELocales },
  'el': { translations: elGRLocales },
  'en': { translations: enUSLocales },
  'es': { translations: esUSLocales },
  'et': { translations: etEELocales },
  'fi': { translations: fiFILocales },
  'fr': { translations: frFRLocales },
  'gu': { translations: guINLocales },
  'he': { translations: heILLocales },
  'hi': { translations: hiINLocales },
  'hr': { translations: hrHRLocales },
  'hu': { translations: huHULocales },
  'it': { translations: itITLocales },
  'ja': { translations: jaJPLocales },
  'ka': { translations: kaGELocales },
  'kn': { translations: knINLocales },
  'ko': { translations: koKRLocales },
  'mr': { translations: mrINLocales },
  'nb': { translations: nbNOLocales },
  'nl': { translations: nlNLLocales },
  'pl': { translations: plPLLocales },
  'pt': { translations: ptPTLocales },
  'ro': { translations: roROLocales },
  'ru': { translations: ruRULocales },
  'sk': { translations: skSKLocales },
  'sr': { translations: srRSLocales },
  'sv': { translations: svSELocales },
  'ta': { translations: taINLocales },
  'te': { translations: teINLocales },
  'th': { translations: thTHLocales },
  'tr': { translations: trTRLocales },
  'xh': { translations: xhZALocales },
  'zh': { translations: zhCNLocales },
  'zu': { translations: zuZALocales },
  'bn': { translations: bnINLocales },
  'ml': { translations: mlINLocales },
  'or': { translations: orINLocales },
  'pa': { translations: paINLocales },
  'ur': { translations: urINLocales },
  'st': { translations: stZALocales },
  'nso': { translations: nsoZALocales },
  'tn': { translations: tnZALocales },
  'fil-PH': { translations: enPHLocales },
};
const storageAvailable = localStorageAvailable();

if (storageAvailable) {
  lng = localStorage.getItem('i18nextLng') || defaultLang.value;
}

const urlParams = new URLSearchParams(window.location.search);
let urlLang = urlParams.get('lang');

if (urlLang && Object.keys(resources).includes(urlLang)) {
  lng = urlLang;
  localStorage.setItem('i18nextLng', lng);
 }

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
        'af-ZA': { translations: afZALocales },
        'ar-IL': { translations: arILLocales },
        'bg-BG': { translations: bgBGLocales },
        'bn-IN': { translations: bnINLocales },
        'cs-CZ': { translations: csCZLocales },
        'da-DK': { translations: daDKLocales },
        'de-AT': { translations: deATLocales },
        'de-BE': { translations: deBELocales },
        'de-CH': { translations: deCHLocales },
        'de-DE': { translations: deDELocales },
        'el-GR': { translations: elGRLocales },
        'en-AU': { translations: enAULocales },
        'en-CA': { translations: enCALocales },
        'en-GB': { translations: enGBLocales },
        'en-IE': { translations: enIELocales },
        'en-NZ': { translations: enNZLocales },
        'en-PH': { translations: enPHLocales },
        'en-SG': { translations: enSGLocales },
        'en-US': { translations: enUSLocales },
        'en-ZA': { translations: enZALocales },
        'es-AR': { translations: esARLocales },
        'es-CL': { translations: esCLLocales },
        'es-CO': { translations: esCOLocales },
        'es-ES': { translations: esESLocales },
        'es-MX': { translations: esMXLocales },
        'es-PR': { translations: esPRLocales },
        'es-US': { translations: esUSLocales },
        'et-EE': { translations: etEELocales },
        'fi-FI': { translations: fiFILocales },
        'fr-BE': { translations: frBELocales },
        'fr-CA': { translations: frCALocales },
        'fr-CH': { translations: frCHLocales },
        'fr-FR': { translations: frFRLocales },
        'gu-IN': { translations: guINLocales },
        'he-IL': { translations: heILLocales },
        'hi-IN': { translations: hiINLocales },
        'hr-HR': { translations: hrHRLocales },
        'hu-HU': { translations: huHULocales },
        'it-CH': { translations: itCHLocales },
        'it-IT': { translations: itITLocales },
        'ja-JP': { translations: jaJPLocales },
        'ka-GE': { translations: kaGELocales },
        'kn-IN': { translations: knINLocales },
        'ko-KR': { translations: koKRLocales },
        'ml-IN': { translations: mlINLocales },
        'mr-IN': { translations: mrINLocales },
        'nb-NO': { translations: nbNOLocales },
        'nso-ZA': { translations: nsoZALocales },
        'or-IN': { translations: orINLocales },
        'pa-IN': { translations: paINLocales },
        'nl-BE': { translations: nlBELocales },
        'nl-NL': { translations: nlNLLocales },
        'pl-PL': { translations: plPLLocales },
        'pt-BR': { translations: ptBRLocales },
        'pt-PT': { translations: ptPTLocales },
        'ro-RO': { translations: roROLocales },
        'ru-RU': { translations: ruRULocales },
        'sk-SK': { translations: skSKLocales },
        'sr-RS': { translations: srRSLocales },
        'st-ZA': { translations: stZALocales },
        'sv-FI': { translations: svFILocales },
        'sv-SE': { translations: svSELocales },
        'ta-IN': { translations: taINLocales },
        'te-IN': { translations: teINLocales },
        'th-TH': { translations: thTHLocales },
        'tn-ZA': { translations: tnZALocales },
        'tr-TR': { translations: trTRLocales },
        'ur-IN': { translations: urINLocales },
        'xh-ZA': { translations: xhZALocales },
        'zh-CN': { translations: zhCNLocales },
        'zh-SG': { translations: zhSGLocales },
        'zh-TW': { translations: zhTWLocales },
        'af': { translations: afZALocales },
        'ar': { translations: arILLocales },
        'bg': { translations: bgBGLocales },
        'cs': { translations: csCZLocales },
        'da': { translations: daDKLocales },
        'de': { translations: deBELocales },
        'el': { translations: elGRLocales },
        'en': { translations: enUSLocales },
        'es': { translations: esUSLocales },
        'et': { translations: etEELocales },
        'fi': { translations: fiFILocales },
        'fr': { translations: frFRLocales },
        'gu': { translations: guINLocales },
        'he': { translations: heILLocales },
        'hi': { translations: hiINLocales },
        'hr': { translations: hrHRLocales },
        'hu': { translations: huHULocales },
        'it': { translations: itITLocales },
        'ja': { translations: jaJPLocales },
        'ka': { translations: kaGELocales },
        'kn': { translations: knINLocales },
        'ko': { translations: koKRLocales },
        'mr': { translations: mrINLocales },
        'nb': { translations: nbNOLocales },
        'nl': { translations: nlNLLocales },
        'pl': { translations: plPLLocales },
        'pt': { translations: ptPTLocales },
        'ro': { translations: roROLocales },
        'ru': { translations: ruRULocales },
        'sk': { translations: skSKLocales },
        'sr': { translations: srRSLocales },
        'sv': { translations: svSELocales },
        'ta': { translations: taINLocales },
        'te': { translations: teINLocales },
        'th': { translations: thTHLocales },
        'tr': { translations: trTRLocales },
        'xh': { translations: xhZALocales },
        'zh': { translations: zhCNLocales },
        'zu': { translations: zuZALocales },
        'fil-PH': { translations: enPHLocales },
    },
    lng,
    fallbackLng: defaultLang.value,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
